import { createFileRoute } from '@tanstack/react-router';
import logo from '../../assets/images/logo.svg';
import Icon from '../../components/icon';
import { seo } from '../../utils/seo';

export const Route = createFileRoute('/_layout/contact')({
  head: () => ({ meta: seo({ title: 'Kapcsolat' }) }),
  component: ContactRoute
});

function ContactRoute() {
  return (
    <div className="container-fluid">
      <div className="page-content centered">
        <h1 className="page-title">Kapcsolat</h1>
        <div className="contact-card">
          <div className="avatar">
            <img className="logo" src={logo} alt="Pixwrist logo" />
          </div>
          <address className="address">
            <div className="address-name">Pixwrist</div>
            <div>
              <a href="mailto:pixwrist@pixwrist.hu" title="E-mail">
                pixwrist@pixwrist.hu
              </a>
            </div>
            {/* <div>3533 Miskolc, Szeder utca 76. 2/6</div>
            <div><a href="tel:+36309219561">+36 30 921 95 61</a></div> */}
          </address>
        </div>
        <ul className="contact-links list-unstyled">
          <li>
            <a
              href="https://www.instagram.com/pixwrist"
              title="Instagram"
              target="_blank"
              rel="noopener"
            >
              <Icon className="icon" name="instagram" size={20} /> Kövess minket
              Instagramon!
            </a>
          </li>
          <li>
            <a
              href="https://www.tiktok.com/@pixwrist"
              title="TikTok"
              target="_blank"
              rel="noopener"
            >
              <svg
                className="icon"
                viewBox="-32 0 512 512"
                height="20"
                width="20"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M432.734 112.465c-53.742 0-97.464-43.723-97.464-97.465 0-8.285-6.72-15-15-15h-80.336c-8.286 0-15 6.715-15 15v329.367c0 31.594-25.704 57.297-57.301 57.297-31.594 0-57.297-25.703-57.297-57.297 0-31.597 25.703-57.3 57.297-57.3 8.285 0 15-6.715 15-15V191.73c0-8.28-6.715-15-15-15C75.199 176.73 0 251.934 0 344.367 0 436.801 75.2 512 167.633 512S335.27 436.8 335.27 344.367V198.574c29.855 15.918 63.074 24.227 97.464 24.227 8.286 0 15-6.715 15-15v-80.336c0-8.281-6.714-15-15-15zm-15 79.715c-32.023-2.664-62.433-13.852-88.707-32.75a14.987 14.987 0 0 0-15.601-1.172 14.99 14.99 0 0 0-8.156 13.347v172.762c0 75.89-61.747 137.633-137.637 137.633S30 420.258 30 344.367c0-70.824 53.773-129.328 122.633-136.824v50.812c-41.016 7.133-72.297 42.985-72.297 86.012 0 48.137 39.16 87.301 87.297 87.301 48.14 0 87.3-39.164 87.3-87.3V30h51.212c6.87 58.32 53.27 104.719 111.59 111.59zm0 0"
                  fill="currentColor"
                />
              </svg>
              Kövess minket TikTokon!
            </a>
          </li>
          <li>
            <a
              href="https://www.facebook.com/pixwrist"
              title="Facebook"
              target="_blank"
              rel="noopener"
            >
              <Icon className="icon" name="facebook" size={20} /> Kövess minket
              Facebookon!
            </a>
          </li>
          <li>
            <a href="mailto:pixwrist@pixwrist.hu" title="E-mail">
              <Icon className="icon" name="mail" size={20} /> Kérdésed van? Írj
              nekünk.
            </a>
          </li>
        </ul>
      </div>
    </div>
  );
}
